import { NotificationManager } from 'react-notifications';
import Cookies from 'universal-cookie';
import { SERVER_API } from "../../../config.json"

const cookies = new Cookies();
let tokenUser = cookies.get('usercode');
function tokenAPI() {
    if (tokenUser.token) {
        return tokenUser.token;
    }
    else {
        NotificationManager.error('Mời bạn đăng nhập lại');
    }
}

function* GetDataMenuAllFromApi() {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + "api/Menu/GetMenuAll", {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + test
        }
    });
    const Data = yield response.json();
    if (Data.status === "OK") {
        return yield Data.data;
    }
    return yield {}
}
function* SetDataMenuFromApi(DataMenu) {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + "api/Menu/InsertMenu", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + test
        },
        body: JSON.stringify(DataMenu),
    });
    const Data = yield response.json();
    if (Data.status === "OK") {
        if (Data.data[0].id === 1) {
            NotificationManager.error("Đã tồn tại menu!");
        }
        else {
            NotificationManager.success("Thêm thành công");
        }
        return yield Data.data;
    }
    return yield {};
}
function* GetDataRolesAllFromApi() {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + "api/Roles/GetRolesAll", {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + test
        }
    });
    const Data = yield response.json();
    if (Data.status === "OK") {
        return yield Data.data;
    }
    return yield {}
}
function* GetDataMenuRolesFromApi() {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + "api/MenuRoles/GetMenuRolesAll", {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + test
        }
    });
    if (response.status === 403) {
        NotificationManager.warning("Bạn không có quyền trên chức năng này !","", 8000);
    }
    else if(response.status === 404)
    {
        NotificationManager.warning("Account đang được đăng nhập trên thiết bị khác. Vui lòng đăng nhập lại.","", 8000);
    }
    else if (response.status === 200) {
        const Data = yield response.json();
        if (Data.status === "OK") {
            return yield Data.data;
        }
    }
    return yield {}
}
//SetMenuRole
function* SetDataMenuRolesFromApi(DataMenuRoles) {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + "api/MenuRoles/InsertMenuRoles", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + test
        },
        body: JSON.stringify(DataMenuRoles),
    });
    if (response.status === 403) {
        NotificationManager.warning("Bạn không có quyền trên chức năng này !","", 8000);
    }
    else if(response.status === 404)
    {
        NotificationManager.warning("Account đang được đăng nhập trên thiết bị khác. Vui lòng đăng nhập lại.","", 8000);
    }
    else if (response.status === 200) {
        const Data = yield response.json();
        if (Data === true) {
            NotificationManager.success("Lưu thành công");
        }
        else {
            NotificationManager.error("Lưu thất bại");
        }
    }
    return yield {};
}
function* DeleteMenuRolesFromApi(ID) {
    var test = tokenAPI();
    const response = yield fetch(SERVER_API + 'api/MenuRoles/Delete?ID=' + ID.ID, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + test
        },
    });
    if (response.status === 403) {
        NotificationManager.warning("Bạn không có quyền trên chức năng này !","", 8000);
    }
    else if(response.status === 404)
    {
        NotificationManager.warning("Account đang được đăng nhập trên thiết bị khác. Vui lòng đăng nhập lại.","", 8000);
    }
    else if (response.status === 200) {
        const Data = yield response.json();
        if (Data === true) {
            NotificationManager.success("Xóa menu role thành công !");
        }
        else {
            NotificationManager.error("Xóa thất bại");
        }
    }
    return yield {};
}
//CreateFuntionHygen
export const Api = {
    GetDataMenuAllFromApi,
    GetDataRolesAllFromApi,
    GetDataMenuRolesFromApi,
    SetDataMenuRolesFromApi,
    DeleteMenuRolesFromApi,
    SetDataMenuFromApi,
    //ExportFuntionHygen
}